/**
 * Supabase Client - Shared with Main Website
 * Same database, same auth system
 * 
 * Simplified configuration to avoid lock issues
 */
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Supabase configuration required. Please check your .env file.');
}

// Singleton instance
let supabaseInstance = null;

// Create or return existing Supabase client instance
const getSupabaseClient = () => {
  if (supabaseInstance) {
    return supabaseInstance;
  }

  // Configuration with session persistence enabled
  supabaseInstance = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      autoRefreshToken: true,
      persistSession: true, // Enable session persistence
      detectSessionInUrl: false,
      flowType: 'pkce',
      debug: false,
      storage: window.localStorage, // Use localStorage for session persistence
      storageKey: 'bpv_supabase_auth',
      lock: (name, acquireTimeout, fn) => fn() // Disable Web Lock to prevent deadlocks in async auth listeners
    },
    db: {
      schema: 'public'
    },
    global: {
      headers: {
        'x-client-info': 'bpv-ecom@1.0.0'
      }
    }
  });

  return supabaseInstance;
};

export const supabase = getSupabaseClient();

// Handle auth errors gracefully
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'TOKEN_REFRESHED' && !session) {
    localStorage.removeItem('bpv_ecom_auth_state');
    sessionStorage.clear();
  } else if (event === 'SIGNED_OUT') {
    localStorage.removeItem('bpv_ecom_auth_state');
    sessionStorage.clear();
  }
});

export default supabase;
